import _ from 'lodash'

/**
 * @var {ApiMiddleware}
 */
let api = {}

/**
 * Set root path for api
 * @param {ApiMiddleware} middlewareObject
 */
export const setTaskTypeApiMiddleware = middlewareObject => {
    api = middlewareObject
}

export default () => ({
    state: {
        taskTypes: [],
    },
    getters: {
        taskTypes: state => state.taskTypes,
        taskTypeById: state => id => _.find(state.taskTypes, ['id', id]),
    },
    mutations: {
        setTaskTypes: (state, taskTypes) => {
            state.taskTypes = taskTypes
        },
        addTaskType: (state, newTaskType) => {
            state.taskTypes.push(newTaskType)
        },
    },
    actions: {
        async taskTypesLoad({ commit }) {
            return api.get('/taskType?depth=2')
                .then(data => {
                    commit('setTaskTypes', data)
                    return data
                })
        },
        async updateTaskType({ commit }, data) {
            return api.put(`/taskType/${data.id}`, data)
                .then(r => {
                    return r
                })
        },
        async createTaskType({ commit }, data) {
            return api.post('/taskType', data)
                .then(r => {
                    return r
                })
        },
    },
})
